import type { ICreativesService } from './ICreativesService';
import { Creative } from 'domains/creative';
import { CreativesApi } from 'infrastructure/apis/creatives/CreativesApi';
import { PaginatedQueryDTO } from 'infrastructure/dtos/pagination/requests/PaginatedQueryDTO';
import { CreativesMapper } from 'infrastructure/mappers/creatives';
import { Paginated } from 'infrastructure/pagination/Paginated';

export class CreativesService implements ICreativesService {
  constructor(private readonly api: CreativesApi) {}

  async getPaginatedCreativesWithPostRequest(
    queryDto: PaginatedQueryDTO
  ): Promise<Paginated<Creative>> {
    const response = await this.api.getPaginatedCreativesWithPostRequest(queryDto);

    return new Paginated(
      response.data.map(item => CreativesMapper.fromDTO(item)),
      response.total,
      response.per_page,
      response.current_page,
      response.last_page
    );
  }
}
